import styled from "styled-components";
import { Button, Container } from "../../../common/styles";
import { theme } from "../../../theme";
import { ReactComponent as Gps } from "./img/gps.svg";

export const Section = styled(Container)`
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8%;
    padding-bottom: 20px;
    @media (max-width: ${theme.breakpoints.tablet}) {
        flex-direction: column;
        gap: 15px;
    }
`;

export const Block = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const StyledButton = styled(Button)`
    margin-bottom: 40px;
    &:hover{
        color: ${theme.colors.colorfulBackground};
        border-color: ${theme.colors.colorfulBackground};
    }
    @media (max-width: ${theme.breakpoints.tablet}) {
        margin-bottom: 0;
    }
`;

export const LocationNameBlock = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    color: ${theme.colors.text};
`;

export const GpsIco = styled(Gps)`
    background-color: ${theme.colors.colorfulBackground};
    color: white;
    border-radius: 50%;
    padding: 10px;
    margin-right: 10px;
    width: 40px;
    height: auto;
    @media (max-width: ${theme.breakpoints.mobile}) {
        width: 30px;
        padding: 7px;
        margin-right: 5px;
    }
`;